import classNames from 'classnames';
import React from 'react';

import { IconTypes } from '@eika/icon';
import { ErrorLabel, InfoLabel, Label, SuccessLabel, WarningLabel } from '@eika/label';

import useText from '@hooks/use-text';

import { Checkmark, InfoText, Title } from './MessageDetails';
import { getErrorText, getErrorTitle } from './functions';
import { MessageType, TextAlign, UNRESPONSIVE_TYPES_LIST } from './types';

import './Message.scss';

interface Props {
    icon?: boolean;
    title?: string | undefined;
    text?: string | undefined;
    role?: string;
    type?: MessageType | undefined;
    textAlign?: TextAlign;
    children?: JSX.Element;
}

export default ({
    icon = false,
    title,
    text,
    role = 'alert',
    type = MessageType.ARTICLE,
    textAlign = TextAlign.CENTER,
    children,
}: Props) => {
    const dictionary = useText();

    switch (type) {
        case MessageType.ERROR:
            return <ErrorLabel icon={icon ? IconTypes.UTROPSTEGN_24 : undefined} text={text} />;
        case MessageType.INFO:
            return <InfoLabel icon={icon ? IconTypes.INFO_24 : undefined} text={text} />;
        case MessageType.SUCCESS:
            return <SuccessLabel icon={icon ? IconTypes.CHECKMARK_TIL_SIRKEL_24 : undefined} text={text} />;
        case MessageType.WARNING:
            return <WarningLabel text={text} />;
        case MessageType.LABEL:
            return <Label icon={icon ? IconTypes.FORDELER_24 : undefined} text={text} />;
        default:
            if (UNRESPONSIVE_TYPES_LIST.includes(type)) {
                title = getErrorTitle(type, dictionary);
                text = text ?? getErrorText(type, dictionary);
            }

            if (typeof text === 'undefined' && !children) {
                return null;
            }

            return (
                <div role={role} className={classNames('message-wrapper', `-${type}`)} style={{ textAlign }}>
                    <Checkmark type={type} />
                    <Title text={title} />
                    <InfoText text={text} />
                    {children}
                </div>
            );
    }
};
